import { atom, useAtom } from "jotai";

export const campaignFiltersAtom = atom<string[]>([]);
export const useCampaignFilters = () => {
  return useAtom(campaignFiltersAtom);
};

export const adsetFiltersAtom = atom<string[]>([]);
export const useAdsetFilters = () => {
  return useAtom(adsetFiltersAtom);
};
